import { Form, Button, Input, Select } from 'antd';

const FormItem = Form.Item;

const WAREHOUSE_STAGE_OPTIONS = [
    { label: '全部', value: 'all' },
    { label: '2025年后入库', value: 'after_2025' },
    { label: '2025年前入库', value: 'before_2025' }
];

/**
 * 未评分数据筛选
 * @param {object} props
 * @param {(values: object) => void} props.onSearch 查询
 * @param {() => void} props.onReset 重置
 * @returns {JSX.Element}
 */
const ProductionUnratedFilterForm = ({ onSearch, onReset }) => {
    const [form] = Form.useForm();

    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    return (
        <Form
            className="amp-business-data-form"
            form={form}
            initialValues={{ warehouse_stage: 'after_2025' }}
            onFinish={(values) => onSearch(values)}
        >
            <FormItem label="资产" name="asset_id_name">
                <Input
                    maxLength={20}
                    className="amp-input-sz-l"
                    placeholder="请输入资产名称及资产ID"
                    allowClear
                />
            </FormItem>
            <FormItem label="入库阶段" name="warehouse_stage">
                <Select
                    className="amp-input-sz-l"
                    options={WAREHOUSE_STAGE_OPTIONS}
                />
            </FormItem>
            <FormItem className="amp-business-data-form-buttons">
                <Button className="amp-btn-sz-s amp-blue-border" onClick={handleReset}>
                    重置
                </Button>
                <Button className="amp-btn-sz-s" type="primary" htmlType="submit">
                    查询
                </Button>
            </FormItem>
        </Form>
    );
};

export default ProductionUnratedFilterForm;
